import * as React from "react";
import { Component } from "react";
import H from "history";
import { Redirect } from "react-router";
import LoadingPage from "../LoadingPage";
import {SchoolsCanAccessResponse} from "../../models/SchoolsCanAccessResponse";

interface HomeRedirectProps {
    history: H.History;
    schoolsCanAccess?: SchoolsCanAccessResponse;
    userIsCdbEmployee: boolean
}

interface HomeRedirectState {
}

export default class HomeRedirect extends Component<HomeRedirectProps,HomeRedirectState> {

    constructor(props: HomeRedirectProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount(): Promise<void> {

    }

    async componentDidUpdate(prevProps: Readonly<HomeRedirectProps>, prevState: any): Promise<void> {
    }

    public render(): JSX.Element | undefined {
        
        if(this.props.userIsCdbEmployee)
        {
            return (
                <Redirect to={"/cdb-admin/home"}/>
            );
        }
        
        if(this.props.schoolsCanAccess === undefined)
        {
            return <LoadingPage/>
        }
        
        if(this.props.schoolsCanAccess.schoolsWithAccessLevels.length === 0)
        {
            return <Redirect to={"/manage/no-access"}/>
        }
        else
        {
            const firstSchoolWithAccessLevel = this.props.schoolsCanAccess.schoolsWithAccessLevels[0];
            return <Redirect to={`/manage/${firstSchoolWithAccessLevel.school.tenantId}/${firstSchoolWithAccessLevel.school.schoolCode}`}/>
        }
    }
}